module.exports = __webpack_public_path__ + "img/ic_login_img.3f666ac5.png";